import { IconButton, Table } from '@salecycle/ui-component-library';
import * as RestApi from 'core/network/RestApi';
import { IBlocklistAllowlistItem } from '../entities/blocklist-allowlist-constants';
import * as React from 'react';
import { Column } from 'react-table';
import useNotifications from 'core/notifications/useNotifications';
import { useMutation } from 'react-query';
import { generatePath, useParams } from 'react-router';
import { SiteSettingsApiEndpoints } from '../../utils/api-endpoints';
import { useTranslation } from 'react-i18next';
import { useMessagePrettifier } from './hooks/useMessagePrettifier';
import { useMemo } from 'react';

interface IProps {
  deleteBlocklistAllowlistCallback: (itemKey: string, listType: string, recordType: string) => void;
  listData: IBlocklistAllowlistItem[];
  isLoading: boolean;
  listType: string;
  valueType: string;
  pageNumber: number;
  setPageNumber: any;
}

export type Props = IProps;

const BlocklistAllowlistTable: React.FC<IProps> = (props: IProps) => {
  const { t } = useTranslation();
  const { p } = useMessagePrettifier();
  const { siteId } = useParams<{ siteId: string }>();
  const { showNotification } = useNotifications();

  const deleteBlocklistAllowListMutation = useMutation((itemKey: string) =>
    RestApi.del(
      generatePath(SiteSettingsApiEndpoints.DELETE_BLOCK_ALLOW_LIST_ITEM, { siteId: siteId, item_key: itemKey }),
    ),
  );

  const deleteItem = async (itemKey: string, listType: string, recordType: string) => {
    deleteBlocklistAllowListMutation.mutate(itemKey, {
      onSuccess: () => {
        showNotification(p(props.valueType, props.listType, 'delete', 'success'), 'normal');
        props.deleteBlocklistAllowlistCallback(itemKey, listType, recordType);
      },
      onError: () => {
        showNotification(p(props.valueType, props.listType, 'delete', 'failure'), 'error');
      },
    });
  };
  const getBlocklistAllowlistTableColumns: Column[] = [
    {
      Header: t(`settings.${props.listType}.table.${props.valueType}NameHeading`),
      accessor: 'name',
      width: 400,
    },
    {
      Header: t(`settings.${props.listType}.table.${props.valueType}Heading`),
      accessor: 'value',
      width: 800,
    },
    {
      Cell: itemKey => {
        return (
          <IconButton
            onClick={() => deleteItem(itemKey.original.itemKey, itemKey.original.listType, itemKey.original.type)}
            ariaLabel={t('Delete')}
            icon="trash"
          />
        );
      },
    },
  ];

  const data = useMemo<IBlocklistAllowlistItem[]>(() => {
    if (props.listData && props.valueType) {
      return props.listData.filter(item => {
        return item.type === props.valueType;
      });
    }
  }, [props.listData, props.valueType]);

  return (
    <>
      <Table
        columns={getBlocklistAllowlistTableColumns}
        data={data}
        defaultPageSize={10}
        defaultSorted={[{ id: 'name', desc: true }]}
        noDataText={props.isLoading ? '' : t(`settings.${props.listType}.table.noData`)}
        loading={props.isLoading}
        loadingText={t(`settings.${props.listType}.table.loadingMessage`)}
        page={props.pageNumber}
        onPageChange={(pageIndex: number): void => {
          props.setPageNumber(pageIndex);
        }}
      />
    </>
  );
};
export default BlocklistAllowlistTable;
